import { $$ } from './core/dom.js';

/**
 * Tal der afhænger af årstallet opdateres af sig selv, så de ikke bliver forældede:
 *   <span data-years-since="2006">20</span>   → aktuelt år minus 2006 (fx "År i dialog")
 *   <span data-current-year>2026</span>       → aktuelt årstal (fx © i footeren)
 * Teksten i HTML'en er blot en reserve, hvis JavaScript ikke kan køre.
 */
export function initYearsSince() {
  const year = new Date().getFullYear();

  $$('[data-years-since]').forEach(el => {
    const since = Number(el.dataset.yearsSince);
    if (Number.isFinite(since)) el.textContent = String(year - since);
  });

  $$('[data-current-year]').forEach(el => {
    el.textContent = String(year);
  });
}
